module.exports = __webpack_public_path__ + "media/images/warning-fill-424c9e95a935e6a2926881f5f805255c5973698c7107fc0e82ec07d32051ad57.svg";